import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class ProvinciasService extends ApiService {
  entityType = EntityType.PROVINCIA;
  url = 'api/provincias/';
}
